// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import PieChartSvg from '@rsuite/icon-font/lib/charts/PieChart';
var PieChart = createSvgIcon({
  as: PieChartSvg,
  ariaLabel: 'pie chart',
  category: 'charts',
  displayName: 'PieChart'
});
export default PieChart;